import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignInComponent } from './sign-in.component';
import { SupportPortalComponent } from './support-portal/support-portal.component';
import { AccessRestrictedComponent } from './access-restricted/access-restricted.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  { path: "sign-in", component: SignInComponent },
  { path: "support-portal", component: SupportPortalComponent },
  { path: "access-restricted", canActivate:[AuthGuard], component: AccessRestrictedComponent },
  { path: "", redirectTo: "sign-in", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignInRoutingModule { }
